// Mobile Landscape Lock & Orientation Overlay Manager for Taronno's Love
// Strictly active on mobile/touch devices; desktop remains 100% untouched.

export class MobileOrientationManager {
  constructor() {
    this.overlay = null;
    this.isMobile = this.detectMobile();
    this.boundCheck = this.checkOrientation.bind(this);
  }

  detectMobile() {
    // Only detect actual phones/tablets with coarse touch pointers
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isCoarse = window.matchMedia('(pointer: coarse)').matches;
    const smallScreen = window.innerWidth <= 1024 || window.innerHeight <= 1024;
    return hasTouch && (isCoarse || smallScreen);
  }

  init() {
    if (!this.isMobile) return;

    this.overlay = document.getElementById('rotate-phone-overlay');
    if (!this.overlay) {
      this.overlay = this.createOverlay();
      document.body.appendChild(this.overlay);
    }

    // Try landscape lock via Screen Orientation API on first user interaction
    const tryLock = () => {
      if (screen.orientation && screen.orientation.lock) {
        screen.orientation.lock('landscape').catch(() => {});
      }
    };
    ['pointerdown', 'touchstart', 'click'].forEach(evt => {
      window.addEventListener(evt, tryLock, { passive: true, once: true });
    });

    window.addEventListener('resize', this.boundCheck);
    window.addEventListener('orientationchange', this.boundCheck);
    if (screen.orientation) {
      screen.orientation.addEventListener('change', this.boundCheck);
    }

    // Initial check
    this.checkOrientation();
  }

  createOverlay() {
    const el = document.createElement('div');
    el.id = 'rotate-phone-overlay';
    el.className = 'rotate-phone-overlay hidden';
    el.innerHTML = `
      <div class="rotate-phone-card">
        <div class="rotate-phone-icon">
          <svg viewBox="0 0 72 72" width="68" height="68" fill="none">
            <rect x="22" y="10" width="28" height="52" rx="6" stroke="#f6dcb7" stroke-width="2.5" fill="rgba(30, 20, 45, 0.85)" />
            <circle cx="36" cy="54" r="2.5" fill="#f6dcb7" />
            <line x1="30" y1="16" x2="42" y2="16" stroke="#f6dcb7" stroke-width="2" stroke-linecap="round" />
            <path d="M54 22 C62 30, 62 44, 54 52" stroke="#ff70a6" stroke-width="3" stroke-linecap="round" stroke-dasharray="4 2" />
            <polygon points="56,54 52,48 58,47" fill="#ff70a6" />
          </svg>
        </div>
        <h2 class="rotate-phone-title">ROTATE YOUR PHONE TO PLAY</h2>
        <p class="rotate-phone-subtitle">Landscape orientation is required to enter the world of Taronno's Love</p>
      </div>
    `;
    return el;
  }

  checkOrientation() {
    if (!this.isMobile || !this.overlay) return;

    // Detect if device is held vertically (portrait)
    const isPortrait = window.innerHeight > window.innerWidth;

    if (isPortrait) {
      this.overlay.classList.remove('hidden');
      if (window.__game && window.__game.loop && !window.__game.loop.sleeping) {
        window.__game.loop.sleep();
      }
    } else {
      this.overlay.classList.add('hidden');
      if (window.__game && window.__game.loop && window.__game.loop.sleeping) {
        window.__game.loop.wake();
      }
      // Notify touch controls to recalculate border widths after orientation switch
      window.dispatchEvent(new Event('mobile-layout-refresh'));
    }
  }

  destroy() {
    window.removeEventListener('resize', this.boundCheck);
    window.removeEventListener('orientationchange', this.boundCheck);
    if (screen.orientation) {
      screen.orientation.removeEventListener('change', this.boundCheck);
    }
  }
}

export const mobileOrientationManager = new MobileOrientationManager();
